import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { PropertyCard } from "./PropertyCard";
import TopBanner from "./TopBanner";
import SearchButton from "./SearchButton";
import {
  allPropertiesSelector,
  setAllProperties,
} from "../redux/allPropertiesSlice";
import {
  clearReduxSearchQuery,
  selectSearchQuerySelector,
} from "../redux/searchQuery";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setPropertyDetails, setUid } from "../redux/propertyIDandSN";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../Axios/axios";
import banner from "../assets/banner.png";
import LogOutButton from "./LogOutButton";
import Cookies from "js-cookie";
import CustomLoader from "./CustomLoader";

const PropertyList = () => {
  const allProperties = useSelector(allPropertiesSelector);
  const dispatch = useDispatch();
  const { uid } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const reduxQuerySelector = useSelector(selectSearchQuerySelector);
  const [managerID, setManagerID] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchDone, setSearchDone] = useState(false);
  const SES = Cookies.get("SES");

  // console.log("allProperties", allProperties);
  // console.log("reduxQuerySelector", reduxQuerySelector);

  const fullList = allProperties?.data?.list || [];

  const filteredList = useMemo(() => {
    const q = reduxQuerySelector || {};
    if (!Object.keys(q).length) return fullList;

    return fullList.filter((p) => {
      // מספרים
      const rooms = Number(p.rooms);
      const reType = Number(p.re_type);
      const dealType = Number(p.deal_type);

      // בחירה
      if (q.re_type && reType !== Number(q.re_type)) return false;
      if (q.deal_type && dealType !== Number(q.deal_type)) return false;

      // טווח חדרים (הכי נפוץ אצלך)
      if (
        q.rooms_from &&
        Number.isFinite(rooms) &&
        rooms < Number(q.rooms_from)
      )
        return false;
      if (q.rooms_to && Number.isFinite(rooms) && rooms > Number(q.rooms_to))
        return false;

      // צ'קבוקסים (1 = חייב להיות 1 אצל הנכס)
      const checkboxKeys = [
        "furnished",
        "pool",
        "air_con",
        "parking",
        "storage",
        "reconditioned",
        "elevator",
        "door_keeper",
        "disabled",
      ];
      for (const k of checkboxKeys) {
        if (q[k] === 1) {
          // בדאטה שלך לפעמים "" במקום 0/1
          const val = p[k];
          const asNum = val === "" ? 0 : Number(val);
          if (asNum !== 1) return false;
        }
      }

      // טקסטים (אופציונלי)
      if (q.city && !String(p.city || "").includes(q.city)) return false;
      if (q.state && !String(p.state || "").includes(q.state)) return false;
      if (q.address && !String(p.street || "").includes(q.address))
        return false;
      if (q.area && !String(p.area || "").includes(q.area)) return false;

      return true;
    });
  }, [fullList, reduxQuerySelector]);

  const initialData = [
    {
      url: "?app=api_re_list",
      key: "lkjads9uasdkj0er9ujerkjlkdjf09dufdlkfjg",
      reducer: setAllProperties,
      uid, // need to change after htaccess fixed
    },
  ];

  const fetchInitialData = () => {
    initialData.map((data) => {
      let formData = new FormData();
      formData.append("key", data.key);
      formData.append("uid", data.uid);
      formData.append("SES", SES);

      axiosInstance.post(data.url, formData).then((response) => {
        // Extract only serializable parts of the response
        const serializedResponse = {
          data: response.data, // Serialized response data
          headers: {
            contentType: response.headers["content-type"], // Specific serialized headers
            contentLength: response.headers["content-length"],
          },
        };

        // Dispatch the serialized response to the Redux store
        dispatch(data.reducer(serializedResponse));

        // Set manager ID if available
        setManagerID(response.data?.manager_id);
        sessionStorage.setItem("mid", response.data.manager_id);

        // console.log(response); // Original response for debugging
      });
    });
  };

  useEffect(() => {
    dispatch(setUid(uid));
    if (!allProperties.length) {
      fetchInitialData();
    }
  }, []);

  const handleListCardClick = (propertyId, propertySecureNum) => {
    dispatch(setPropertyDetails({ propertyId, propertySecureNum }));
  };

  const handleClear = () => {
    dispatch(clearReduxSearchQuery());
  };
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <Grid
      container
      sx={{ width: "100%", maxWidth: "100%", backgroundColor: "#F9FBFC" }}
      justifyContent={"center"}
      alignItems={"center"}
      dir="rtl"
    >
      <Grid
        container
        justifyContent={"flex-start"}
        alignItems={"center"}
        size={12}
        sx={{ width: "100%" }}
      >
        <Grid item sx={{ width: "100%" }}>
          <TopBanner mainTopImage={banner} propLogo={allProperties.data?.adv} />
        </Grid>
      </Grid>
      <Grid container sx={{ width: "100%" }}>
        {managerID === uid ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ p: "15px" }}
          >
            <Grid item alignItems="center">
              <Link to={`/${uid}/addnewproperty`} state={managerID}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "white",
                    backgroundColor: "#1B1A55",
                    borderRadius: "5px",
                    width: "250px",
                  }}
                >
                  הוספת נכס חדש
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ p: "15px" }}
              >
                <LogOutButton />
              </Grid>
            </Grid>
          </Grid>
        ) : managerID === null ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ p: "15px" }}
          >
            <Grid item alignItems="center">
              <Link to="/login" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "white",
                    backgroundColor: "#1B1A55",
                    borderRadius: "5px",
                    width: "250px",
                  }}
                >
                  כניסה
                </Button>
              </Link>
            </Grid>
          </Grid>
        ) : null}
      </Grid>

      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ pb: "20px" }}
      >
        <Grid item xs={6}>
          <SearchButton />
        </Grid>
        <Grid item xs={6}>
          {Object.keys(reduxQuerySelector).length > 0 ? (
            <Button
              onClick={() => {
                handleClear();
                reloadPage();
              }}
            >
              נקה חיפוש
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <Typography sx={{ pb: 2 }}>{filteredList.length} נכסים נמצאו</Typography>
      <Grid
        container
        dir="rtl"
        size={12}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ width: "100%" }}
      >
        <Grid item xs={12}>
          <Typography sx={{ pb: 2 }}>
            לצפייה בפרטי הנכס לחצו על התמונה
          </Typography>
        </Grid>
        {
          // 1. Search loading
          searchLoading ? (
            <CustomLoader />
          ) : // 2. Initial load before any data exists
          !allProperties?.data ? (
            <CustomLoader />
          ) : // 3. LIST EXISTS BUT EMPTY → check if it's initial load or search
          Array.isArray(allProperties.data.list) &&
            filteredList.length === 0 ? (
            searchDone ? (
              <Typography sx={{ p: 2, fontSize: "18px", opacity: 0.7 }}>
                לא נמצאו נכסים
              </Typography>
            ) : (
              <Typography sx={{ p: 2, fontSize: "18px", opacity: 0.7 }}>
                עדיין לא הועלו נכסים
              </Typography>
            )
          ) : // 4. SHOW LIST WHEN IT EXISTS AND HAS ITEMS
          Array.isArray(allProperties.data.list) ? (
            filteredList.map((property) => (
              <Grid
                item
                key={property.id}
                sx={{ p: "10px" }}
                onClick={() =>
                  handleListCardClick(property.id, property.secure_num)
                }
              >
                <PropertyCard
                  propertyId={property.id}
                  propertySecureNum={property.secure_num}
                  propertyName={property.title}
                  propertyImage={property.image}
                  propertyAddress={property.street}
                  propertyPrice={property.price}
                  propertyType={property.re_type}
                  rooms={property.rooms}
                  baths={property.bathrooms}
                  parking={property.parking}
                  propertySqm={property.square}
                  propertySqmType={property.square_type}
                  saleOrRent={property.deal_type}
                  fornitured={property.furnished}
                  coin={property.coin}
                  agentPhoneNumber={property.re_phone1}
                  waze={property.waze}
                  managerID={managerID}
                  spitimou_rid={property.spitimou_rid}
                  uid={uid}
                />
              </Grid>
            ))
          ) : (
            // 5. fallback (should never run)
            <Typography sx={{ p: 2, fontSize: "18px", opacity: 0.7 }}>
              לא נמצאו נכסים
            </Typography>
          )
        }
      </Grid>
    </Grid>
  );
};

export default PropertyList;
